export const environment = {
  idleTimeout: 3600000,
  production: false,
  addressVerificationEnabled: true,
  apiUrl: 'https://api-test.creconnects.com',
  recaptchaSiteKey: '6Ld7gmMqAAAAAKR67YHtYbEvVSCi25V4CDH9jGs-',
  env: 'test',
};
